export default __webpack_public_path__ + "static/media/JobSix11.d8ced691.jpg";